import { render, staticRenderFns, recyclableRender, components } from "./verify-address.vue?vue&type=template&id=72a1777a&"
var renderjs
import script from "./verify-address.vue?vue&type=script&lang=js&"
export * from "./verify-address.vue?vue&type=script&lang=js&"
import style0 from "./verify-address.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order/confirm-order/address/verify-address.vue"
export default component.exports